import React, { ReactElement, useRef } from 'react';
import { HashLink } from '../../Devon/Components/InkyLink';
import { scrollToItem } from '../../utils/utils';
import './SupportCenterPageLinksTemp.scss';

export default function SupportCenterPageLinksTemp(): ReactElement {
    const commonRef = useRef(null);
    const accountRef = useRef(null);
    return (
        <div className='support-center-page-links-temp-wrapper'>
            <div className='quicklinks'>
                <div className='quicklinks-col'>
                    <p>Need help?</p>
                    <p><HashLink targetId='contact-us-support'>Contact Us</HashLink> in the form below</p>
                </div>
                <div
                    className='quicklinks-col'
                    onClick={(): void => {
                        if (commonRef.current) {
                            scrollToItem(commonRef.current, 150);
                        }
                    }}
                >
                    <p>Not sure where to start?</p>
                    <p>Take a look at the <HashLink targetId='common-questions'>Common Questions</HashLink></p>
                </div>
                <div
                    className='quicklinks-col'
                    onClick={(): void => {
                        if (accountRef.current) {
                            scrollToItem(accountRef.current, 150);
                        }
                    }}
                >
                    <p>Trouble with an account or order?</p>
                    <p>Review our <HashLink targetId='technical-questions'>Technical Support</HashLink></p>
                </div>
            </div>
        </div>
    );
}